<script>
    import app from "../stores/app";
    import user from "../stores/user";
    import transfers from "../stores/transfers";
    import {TRANSFER_STATUS} from "../lib/constants";
    import {formatDate} from "../lib/lib";
    import {createEventDispatcher} from 'svelte/internal';

    const paymentTypes = [
        'On Account', 'Cache', 'CPL',
    ];

    const transferStatus = [
        {id: 0, icon: '', name: 'Open'},
        {id: 1, icon: 'circle', name: 'Assigned'},
        {id: 2, icon: 'circle-check', name: 'Closed'},
        {id: 3, icon: 'cancel', name: 'Canceled'},
    ];

    const dispatch = createEventDispatcher();

    const onEdit = (transfer_id) => {
        if (user.canEditTransfers()) {
            dispatch("edit", transfer_id);
        } else {
            dispatch("view", transfer_id);
        }
    }
</script>

<div class="transfers-grid">
    {#each $transfers.list as transfer}
        <div class="transfer-item route route-type-{ transfer.route_type }"
             class:selected="{ $transfers.selectedId === transfer.id }">
            <div class="cell-row route pointer border-bottom"
                 class:status-assigned={ transfer.status_id == TRANSFER_STATUS.ASSIGNED}
                 class:status-canceled={ transfer.status_id == TRANSFER_STATUS.CANCELED}
                 class:status-closed={ transfer.status_id == TRANSFER_STATUS.CLOSED}
                 on:click="{ () => onEdit(transfer.id) }"
            >
                <div class="cell location text-truncate">
                    { transfer.pickup_name } → { transfer.drop_name }
                </div>
                <div class="cell date">
                    { formatDate(transfer.transfer_at, 'd-m-y H:i') }
                </div>
            </div>

            <div class="customer-passengers">
                <div class="cell-row customer border-bottom text-gray">
                    <div class="cell fullname">
                        <div class="small">Customer</div>
                        { transfer.customer.fullname }
                    </div>
                    <div class="cell room-no">
                        <div class="small">Room No</div>
                        { transfer.customer.room_no }
                    </div>
                    <div class="cell flight-no">
                        <div class="small">Flight No</div>
                        { transfer.flight_no }
                    </div>
                </div>

                <div class="cell-row passengers text-gray border-bottom">
                    <div class="cell text-center">
                        <div class="small">Adults</div>
                        { transfer.adults }
                    </div>
                    <div class="cell text-center">
                        <div class="small">Children</div>
                        {#if transfer.children > 0}
                            { transfer.children }
                        {/if}
                    </div>
                    <div class="cell text-center">
                        <div class="small">Infants</div>
                        {#if transfer.infants > 0}
                            { transfer.infants }
                        {/if}
                    </div>
                    <div class="cell text-center">
                        <div class="small">Total</div>
                        { transfer.passengers }
                    </div>
                </div>
            </div>

            <div class="drivers">
                {#each transfer.vehicles as item, index}
                    <div class="cell driver">
                        <div class="small">Driver { transfer.vehicles.length > 1 ? index + 1 : '' }</div>
                        {#if item.vehicle && item.driver}
                            <div class="text-gray">
                                { item.vehicle.licence_no }
                                { item.driver.name}
                            </div>
                        {:else}
                            <div class="text-light">
                                { app.vehicleTypeName(item.vehicle_type_id) }
                            </div>
                        {/if}
                    </div>
                {/each}
            </div>

            <div class="cell-row text-gray">
                <div class="cell">
                    {#if transfer.price}
                        € { transfer.price }
                    {/if}
                </div>
                <div class="cell">
                    { paymentTypes[transfer.payment_type] }
                </div>
                <div class="cell">
                    { transferStatus[transfer.status_id].name }
                </div>
            </div>
        </div>
    {/each}
</div>

<style>
    .transfer-item {
        background: #fff;
        border: 1px solid var(--table-border-color);
        border-left-width: 5px;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    .transfer-item:hover, .transfer-item.selected {
        box-shadow: 0 1px 15px rgba(0, 0, 0, 0.15);
        -webkit-box-shadow: 0 1px 15px rgba(0, 0, 0, 0.15);
        -moz-box-shadow: 0 1px 15px rgba(0, 0, 0, 0.15);
        transition: all .2s ease-in-out;
    }

    .transfer-item .border-bottom {
        border-bottom: 1px dotted var(--table-border-color) !important;
    }

    .transfer-item.route-type-0 {
        border-left-color: var(--default-border-color);
    }

    .transfer-item.route-type-1 {
        border-left-color: var(--route-arrival-color);
    }

    .transfer-item.route-type-2 {
        border-left-color: var(--route-departure-color);
    }

    .transfer-item.route-type-3 {
        border-left-color: var(--route-tour-color);
    }

    .transfer-item .cell-row {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
    }

    .transfer-item .customer-passengers {

    }

    .transfer-item .customer-passengers .customer {
        width: 100%;
    }

    .transfer-item .customer-passengers .passengers {

    }

    .transfer-item .cell {
        padding: 10px 10px;
    }

    .transfer-item .cell.fullname {
        width: calc(100% - 180px);
    }

    .transfer-item .cell.room-no {
        width: 90px;
    }

    .transfer-item .cell.flight-no {
        width: 90px;
    }

    .transfer-item .drivers {
        width: 100%;
    }

    .transfer-item .drivers .driver {
    }

    .transfer-item .small {
        font-size: 0.6rem;
        line-height: 1;
        color: #999;
    }

    .status-assigned {
        background: var(--status-assigned-background);
    }

    .status-canceled {
        background: var(--status-canceled-background);
    }

    .status-closed {
        background: var(--status-closed-background);
    }

    @media (max-width: 576px) {
        .transfer-item .route {
            display: block;
        }

        .transfer-item .route .location {
            padding-bottom: 0;
        }

        .transfer-item .route .date {
            padding-top: 0;
        }
    }

    @media (max-width: 767px) {
        .transfer-item .drivers .driver {
            border-bottom: 1px dotted var(--table-border-color) !important;
        }
    }

    @media (min-width: 768px) {
        .transfer-item .customer-passengers {
            display: flex;
        }

        .transfer-item .drivers {
            display: flex;
            flex-wrap: wrap;
            border-bottom: 1px dotted var(--table-border-color) !important;
        }

        .transfer-item .drivers .driver {
            width: 50%;
            border-bottom: none;
        }
    }

    /* Medium devices (tablets, 768px and up) (col-sm) */
    @media (min-width: 768px) and (max-width: 991px) {

    }

    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) and (max-width: 1199px) {

    }

    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {

    }
</style>